import React from 'react';
import { motion } from 'framer-motion';
import { companyStats } from '../data/home';
export function StatsSection() {
  return <section className="bg-midnight-navy py-24 md:py-32" data-id="element-193" data-mp="q5bq338zq8nh">
      <div className="max-w-7xl mx-auto px-6" data-id="element-194" data-mp="14sn0h1tfrmm0">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-2xl mb-16 space-y-5" data-id="element-195" data-mp="14ug4sagktuqu">
          <span className="text-royal-blue text-xs font-bold uppercase tracking-[0.2em]" data-id="element-196" data-mp="1nsamdcvrteku">
            Why ROI Complete
          </span>
          <h2 className="text-stark-white text-3xl md:text-5xl font-montserrat font-extrabold leading-tight tracking-tight" data-id="element-197" data-mp="1it7fdmw8cya8">
            Decades of operating experience, now backed by technology.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-2xl overflow-hidden" data-id="element-198" data-mp="3kmdt9xwaa2hg">
          {companyStats.map((stat, idx) => <motion.div key={stat.label} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1,
          ease: 'easeOut'
        }} className="bg-midnight-navy p-10 space-y-3" data-id="element-199" data-mp="whpbd2f0jqoj" data-mpi={idx}>
              <div className="text-royal-blue text-4xl md:text-5xl font-montserrat font-extrabold tracking-tight" data-id="element-200" data-mp="1k4xfhh0pgtoz">
                {stat.value}
              </div>
              <div className="text-stark-white/50 text-sm font-semibold uppercase tracking-widest leading-relaxed" data-id="element-201" data-mp="3lzocmlhmhuer">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}